import { cn } from './util.ts'

const tones = [
  'bg-viz-1/15 text-viz-1 ring-viz-1/30',
  'bg-viz-2/15 text-viz-2 ring-viz-2/30',
  'bg-viz-3/15 text-viz-3 ring-viz-3/30',
  'bg-viz-4/15 text-viz-4 ring-viz-4/30',
  'bg-viz-5/15 text-viz-5 ring-viz-5/30',
  'bg-viz-6/15 text-viz-6 ring-viz-6/30',
]

const sizes = {
  xs: 'size-5 text-xs',
  sm: 'size-6 text-xs',
  md: 'size-8 text-sm',
  lg: 'size-12 text-lg',
  xl: 'size-16 text-xl',
}
const squareRadius = { xs: 'rounded-xs', sm: 'rounded-sm', md: 'rounded-md', lg: 'rounded-lg', xl: 'rounded-xl' }

function hash(s: string): number {
  let h = 0
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0
  return Math.abs(h)
}

export interface AvatarProps {
  /** Initials to show ('KV'), or a name to take them from. Never a photo. */
  initials?: string
  name?: string
  size?: keyof typeof sizes
  /** Round for people, square for organisations. */
  shape?: 'round' | 'square'
  masked?: boolean
  className?: string
}

/** Monogram avatar: <Avatar initials="KV" />. Colour is stable per initials. */
export function Avatar({ initials, name, size = 'md', shape = 'round', masked, className }: AvatarProps) {
  const text = (initials ?? (name ?? '?').split(/\s+/).map((w) => w[0] ?? '').join('')).slice(0, 2).toUpperCase()
  return (
    <span
      aria-hidden
      className={cn(
        'inline-flex shrink-0 items-center justify-center font-display font-semibold ring-1 ring-inset select-none',
        sizes[size],
        shape === 'round' ? 'rounded-full' : squareRadius[size],
        masked ? 'bg-hover text-ink-muted ring-line-strong' : tones[hash(text) % tones.length],
        className,
      )}
    >
      {text}
    </span>
  )
}
